import { Card } from 'semantic-ui-react'
import './styles.less'
import { Tag } from '../../components/tag/styles'
import { Novo } from '../../pages/viewer/styles'
import { PropsCardFormType } from './types'

export const CardForm = ({
  requerAtencao = undefined,
  novo = undefined,
  titulo = undefined,
  children
}: PropsCardFormType) => {
  return <Card fluid className='card-form'>
    <Card.Content>
      <Card.Header>
        <Tag
          requer_atencao={requerAtencao}
          novo={novo}
          marginTop="-1.5rem"
          className='form-tag'
        />
        {novo && <Novo className='novo'>NOVO</Novo>}
        <h1>{titulo}</h1>
      </Card.Header>
      {children}
    </Card.Content>
  </Card>
}
